import mixpanel from 'mixpanel-browser'

const log = (val) => {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.log(
      val,
      'font-size: 1em; padding: 0.25em 1em; margin: 0.25em 0; color: white; background-color: #26ac75; border-radius: 6px;'
    )
  }
}

export default function (Vue, options) {
  const { token } = options
  mixpanel.init(token, {
    debug: process.env.VUE_APP_ENVIRONMENT !== 'production'
  })
  log('%cMixpanel Initialized')
  Vue.prototype.$mixpanel = mixpanel

  // Create a user profile as soon as the user logs in
  Vue.prototype.$mpCreateProfile = (payload) => {
    // Identify to be used with people.set_once
    mixpanel.identify(+payload.id)
    mixpanel.people.set_once({
      'First Login Date': new Date(),
      $email: payload.email,
      $name: payload.name,
      'Default user Id': +payload.link_id,
      'Default user Company': payload.company,
      Role: payload.role,
      'Roles List': payload.roles_list
    })
  }

  // code for user tracking, as user can change for a single user.
  Vue.prototype.$mpRegister = (payload) => {
    mixpanel.register({
      'Current user': payload.company,
      'Current user Id': +payload.link_id,
      business_id: +payload.link_id,
      user_id: +payload.id,
      IP: payload.IP
    })
  }

  // Custom component instance to track events
  Vue.prototype.$mpTrack = (event, payload) => mixpanel.track(event, payload)
  Vue.prototype.$mpTimeEvent = (event) => mixpanel.time_event(event)

  // Link Tracking
  Vue.directive('trackClick', {
    inserted: (el, binding, vnode) => {
      el.addEventListener('click', () => {
        log(`%c"${el.id}" clicked`)
        mixpanel.track(`${el.id}-clicked`)
      })
    }
  })

  // Link Tracking
  Vue.directive('trackLink', {
    inserted: (el, binding, vnode) => {
      el.addEventListener('click', (e) => {
        log(`%c"${el.innerText}" clicked`)
        mixpanel.track(`${el.innerText}-clicked`)
      })
    }
  })
}
